import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  count: number = 0
  status$: Observable<number>;

  private subject = new BehaviorSubject<number>(0);

  constructor() {
    this.status$ = this.subject.asObservable().pipe(delay(0));
  }

  set(): void {
    this.count++;
    this.subject.next(this.count);
  }

  decrement(): void {
    this.count--;
    if (this.count < 0) this.count = 0;
    this.subject.next(this.count)
  }
}
